export default "__VITE_ASSET__27b9c7f4__"